export default "__VITE_ASSET__BpSp99AD__"